import { z } from 'zod';
import { uuidSchema } from './common.js';
export const mediaKindSchema = z.enum([
    'vehicle_photo',
    'mockup',
    'logo',
    'job_photo',
    'material_swatch',
    'print_artwork',
    'print_layout',
    'print_render',
]);
export const uploadMediaFieldsSchema = z.object({
    kind: mediaKindSchema,
    vehicleId: uuidSchema.optional(),
    quoteId: uuidSchema.optional(),
    jobId: uuidSchema.optional(),
    designId: uuidSchema.optional(),
});
export const mediaAssetSchema = z.object({
    id: uuidSchema,
    kind: mediaKindSchema,
    url: z.string(),
    thumbUrl: z.string().nullable(),
    width: z.number().int().nullable(),
    height: z.number().int().nullable(),
    createdAt: z.string(),
});
export const signedUrlResponseSchema = z.object({
    url: z.string(),
    expiresAt: z.string(),
});
//# sourceMappingURL=media.js.map